import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    StackReportDashboardData,
    StackReportDashboardState,
    StackReportFilterUpdate,
    StackReportUnitTypeModeChange,
} from "./types";

const initialState: StackReportDashboardState = {
    data: null,
    showSettings: true,
    isFiltersModalOpen: false,
    isAreasEditModalOpen: false,
    chart: {
        pointBackgroundColor: {},
    },
    filter: {
        caseNames: null,
        startDate: null,
        endDate: null,
        areas: null, // value must be adjacency list
        fuelTypes: null,
        scenarios: null,
        unitTypes: null,
        areasAgg: null,
    },
};

export const stackReportDashboardSlice = createSlice({
    name: "stackReportDashboard",
    initialState,
    reducers: {
        updateFilter(state, action: PayloadAction<StackReportFilterUpdate>) {
            const {
                caseNames,
                startDate,
                endDate,
                scenarios,
                areas,
                unitTypes,
                fuelTypes,
                areasAgg,
            } = action.payload;

            if (caseNames !== undefined) {
                state.filter.caseNames = caseNames;
            }

            if (startDate !== undefined) {
                state.filter.startDate = startDate;
            }

            if (endDate !== undefined) {
                state.filter.endDate = endDate;
            }

            if (scenarios !== undefined) {
                state.filter.scenarios = scenarios;
            }

            if (areas !== undefined) {
                state.filter.areas = areas;
            }

            if (unitTypes !== undefined) {
                state.filter.unitTypes = unitTypes;
            }

            if (fuelTypes !== undefined) {
                state.filter.fuelTypes = fuelTypes;
            }

            if (areasAgg !== undefined) {
                state.filter.areasAgg = areasAgg;
            }
        },
        setDashboardResult(state, action: PayloadAction<StackReportDashboardData>) {
            state.data = action.payload;
        },
        changeUnitTypeMode(state, action: PayloadAction<StackReportUnitTypeModeChange>) {
            const items = state.filter.unitTypes?.items;

            if (!items) {
                return;
            }

            items.forEach((item) => {
                if (action.payload.keys.includes(item.idx)) {
                    item.mode = action.payload.mode;
                }
            });
        },
        resetDashboardResult(state) {
            state.data = initialState.data;
        },
        setChartPointColor(state, action: PayloadAction<Record<string, string>>) {
            state.chart.pointBackgroundColor = action.payload;
        },
        toggleFiltersModal(state) {
            state.isFiltersModalOpen = !state.isFiltersModalOpen;
        },
        toggleAreasEditModal(state) {
            state.isAreasEditModalOpen = !state.isAreasEditModalOpen;
        },
        resetScreen() {
            return { ...initialState };
        },
    },
});

export const actions = stackReportDashboardSlice.actions;
export default stackReportDashboardSlice.reducer;
